import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitionsService } from 'src/app/services/exhibitions/exhibitions.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-exhibition-detail',
  templateUrl: './exhibition-detail.page.html',
  styleUrls: ['./exhibition-detail.page.scss'],
})
export class ExhibitionDetailPage implements OnInit {

  item;
  isLinear = false;
  @Input() id

  constructor(
    private exhibitionsService: ExhibitionsService,
    private route: ActivatedRoute,
    public languageService: LanguagesService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getDataDocument();
  }

  get getTextsIUPageExhibitions() {
    return this.languageService.textsIU.page_exhibitions;
  }

  getDataDocument() {
    this.exhibitionsService.getDetail(this.id).then((data: any ) => {
      this.item = data;
    })
  }


}
